enum FormName {
  DISCOUNT_FILTER_FORM = 'DISCOUNT_FILTER_FORM',
  DISCOUNT_DETAILS_FORM = 'DISCOUNT_DETAILS_FORM',
}

export default FormName;
